import enTranslations from '../assets/locale/messages_en.json';
import csTranslations from '../assets/locale/messages_cs.json';
import daTranslations from '../assets/locale/messages_da.json';
import deTranslations from '../assets/locale/messages_de.json';
import esTranslations from '../assets/locale/messages_es.json';
import frTranslations from '../assets/locale/messages_fr.json';
import itTranslations from '../assets/locale/messages_it.json';
import jaTranslations from '../assets/locale/messages_ja.json';
import koTranslations from '../assets/locale/messages_ko.json';
import nlTranslations from '../assets/locale/messages_nl.json';
import idTranslations from '../assets/locale/messages_id.json';
import noTranslations from '../assets/locale/messages_no.json';
import plTranslations from '../assets/locale/messages_pl.json';
import ptTranslations from '../assets/locale/messages_pt.json';
import ruTranslations from '../assets/locale/messages_ru.json';
import svTranslations from '../assets/locale/messages_sv.json';
import thTranslations from '../assets/locale/messages_th.json';
import trTranslations from '../assets/locale/messages_tr.json';
import ukTranslations from '../assets/locale/messages_uk.json';
import zhTranslations from '../assets/locale/messages_zh.json';
import viTranslations from '../assets/locale/messages_vi.json';
const translationsMap = {
  en: enTranslations,
  cs: csTranslations,
  da: daTranslations,
  de: deTranslations,
  es: esTranslations,
  fr: frTranslations,
  it: itTranslations,
  ja: jaTranslations,
  ko: koTranslations,
  nl: nlTranslations,
  id: idTranslations,
  no: noTranslations,
  pl: plTranslations,
  pt: ptTranslations,
  ru: ruTranslations,
  sv: svTranslations,
  th: thTranslations,
  tr: trTranslations,
  uk: ukTranslations,
  zh: zhTranslations,
  vi: viTranslations
};
export const getTranslations = locale => {
  const t = key => {
    var _translationsMap$loca;
    return ((_translationsMap$loca = translationsMap[locale]) == null ? void 0 : _translationsMap$loca[key]) ?? enTranslations[key] ?? key;
  };
  return {
    t
  };
};
//# sourceMappingURL=translations.js.map